import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  id: "hire-me",
  class: "section-cta py-5 bg-primary text-white"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "profile-small d-inline-block mx-auto rounded-circle mb-2",
    src: "/images/profile.png",
    alt: ""
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("h3", { class: "section-title font-weight-bold text-center mb-2" }, " Interested in hiring me for your project? ", -1)
const _hoisted_5 = { class: "section-intro mx-auto text-center mb-3" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Looking for an experienced full-stack developer to build your web app or ship your software product? To start an initial chat, just drop me an email at ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" or use the ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("form on the contact page")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Let's Talk")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode("a", {
          class: "link-on-bg text-link",
          href: `mailto:${_ctx.contactEmail}`
        }, _toDisplayString(_ctx.contactEmail), 9, ["href"]),
        _hoisted_7,
        _createVNode(_component_router_link, {
          class: "link-on-bg text-link",
          to: { name: 'contact' }
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _hoisted_9
      ]),
      _createVNode("div", _hoisted_10, [
        _createVNode(_component_router_link, {
          class: "theme-btn-on-bg btn",
          to: { name: 'contact' }
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ])
    ])
  ]))
}